import { fork, all } from 'redux-saga/effects';

import * as addProduct from './addProduct';
import * as deleteProducts from './deleteProducts';
import * as filters from './filters';
import * as indicatorsSagas from './indicators';
import * as infoSagas from './info';
import * as registerTrade from './registerTrade';
import * as reportSagas from './reports';
import * as getMAssiveUploadSagas from './massiveUpload';
import * as rules from './rules';
import * as table from './table';
import * as upload from './uploadTradeAgreements';
import * as agreement from './agreement';
import * as generateReport from './generateReport';
import * as rejectTradeAgreement from './rejectTradeAgreement';
import * as validProductsForDeleting from './validProductsForDeleting';
//secondValidation
import * as secondValidation from './secondValidation';

export default function* rootSaga() {
  yield all(
    [
      ...Object.values(addProduct),
      ...Object.values(deleteProducts),
      ...Object.values(filters),
      ...Object.values(indicatorsSagas),
      ...Object.values(infoSagas),
      ...Object.values(registerTrade),
      ...Object.values(reportSagas),
      ...Object.values(getMAssiveUploadSagas),
      ...Object.values(rules),
      ...Object.values(table),
      ...Object.values(upload),
      ...Object.values(agreement),
      ...Object.values(generateReport),
      ...Object.values(rejectTradeAgreement),
      ...Object.values(validProductsForDeleting),
      ...Object.values(secondValidation),
    ].map(fork)
  );
}
